<!-- 商业能力 -->
<template>
  <div class="capabilities">
    <div class="card-head">
      <span class="title">商业能力分析</span>
      <el-dropdown trigger="click" :disabled="industryClickDisabled" @command="industryClick">
          <span class="el-dropdown-link" :disabled="industryClickDisabled">
            {{ "行业:"+industryData.category_name }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" >
              <el-dropdown-item  v-for="(item,index) in industry" :command="item" :key="index" :disabled="industryClickDisabled">{{item.category_name}}</el-dropdown-item>
          </el-dropdown-menu>
      </el-dropdown>
    </div>

    <div class="tab-card-group">
        <div class="tab-card-item link-card"
        :class="currentActiveTabIndex === 0?'is-active':''"
        @click="switchActiveCard(0)">
        <div class="relative-ratio">
          <span class="ratio-label">30天环比</span>
          <span class="ratio-value decline" v-if="!linkInfo.link_star_index">-</span>
          <span class="ratio-value decline" v-else
                :class="linkInfo.link_star_index.link_relative_ratio>0 ? 'colorRed':'colorGreen'">
                {{linkInfo.link_star_index.link_relative_ratio > 0?'+ ':''}}
            {{fmt(linkInfo.link_star_index.link_relative_ratio*100, {micrometer: true})||'-'}}%
          </span>
        </div>
        <div class="link-info">
          <span class="icon-tooltip-label link-label">
            <span class="text">星图指数</span>
            <span class="el-tooltip icon right"></span>
          </span>
          <div class="link-value">{{linkInfo?.link_star_index?.value||"-"}}</div>
        </div>
        <div class="rank">
          <span class="rank-label">行业排名</span>
          <div class="rank-value">{{handleRankPercent(linkInfo?.link_star_index?.rank_percent)||"-"}}</div>
        </div>
        </div>

        <div class="tab-card-item link-card"
        :class="currentActiveTabIndex === 1 ?'is-active':''"
        @click="switchActiveCard(1)">
          <div class="relative-ratio">
            <span class="ratio-label">30天环比</span>
            <span class="ratio-value decline" v-if="!exponentList?.length>0">-</span>
            <span class="ratio-value decline" v-else :class="exponentList[0]?.link_relative_ratio>0 ? 'colorRed':'colorGreen'">
              {{exponentList[0]?.link_relative_ratio > 0?'+ ':''}}
              {{fmt(exponentList[0]?.link_relative_ratio*100, {micrometer: true})||'-'}}%
            </span>
          </div>
          <div class="link-info">
            <span class="icon-tooltip-label link-label">
              <span class="text">传播指数</span>
              <span class="el-tooltip icon right"></span>
            </span>

            <div class="link-value">{{ exponentList?.length>0 ? exponentList[0]?.value:'-' }}</div>
          </div>
          <div class="rank">
            <span class="rank-label">行业排名</span>
            <div class="rank-value">{{ exponentList?.length>0 ?
                exponentList[0]?.rank<100 ? exponentList[0]?.rank:
                    handleRankPercent(exponentList[0]?.rank_percent) :'-' }}</div>
          </div>
        </div>

        <div class="tab-card-item link-card"
        :class="currentActiveTabIndex === 2?'is-active':''"
        @click="switchActiveCard(2)">
        <div class="relative-ratio">
          <span class="ratio-label">30天环比</span>
          <span class="ratio-value decline" v-if="!exponentList?.length>1">-</span>
          <span class="ratio-value decline" v-else
                :class="exponentList[1]?.link_relative_ratio>0 ? 'colorRed':'colorGreen'">
                {{exponentList[1]?.link_relative_ratio > 0?'+ ':''}}
            {{fmt(exponentList[1]?.link_relative_ratio*100, {micrometer: true})||'-'}}%
          </span>
        </div>
        <div class="link-info">
          <span class="icon-tooltip-label link-label">
            <span class="text">种草指数</span>
            <span class="el-tooltip icon right"></span>
          </span>
          <div class="link-value">{{ exponentList?.length>1 ? exponentList[1]?.value:'-' }}</div>
        </div>
        <div class="rank">
          <span class="rank-label">行业排名</span>
          <div class="rank-value">{{ exponentList?.length>1 ?
                exponentList[1]?.rank<100 ? exponentList[1]?.rank:
                    handleRankPercent(exponentList[1]?.rank_percent) :'-' }}</div>
        </div>
        </div>

        <div class="tab-card-item link-card"
        :class="currentActiveTabIndex === 3?'is-active':''"
          @click="switchActiveCard(3)">
          <div class="relative-ratio">
            <span class="ratio-label">30天环比</span>
            <span class="ratio-value decline" v-if="!exponentList?.length>2">-</span>
            <span class="ratio-value decline" v-else
                  :class="exponentList[2]?.link_relative_ratio>0 ? 'colorRed':'colorGreen'">
                  {{exponentList[2]?.link_relative_ratio > 0?'+ ':''}}
              {{fmt(exponentList[2]?.link_relative_ratio*100, {micrometer: true})||'-'}}%
            </span>
          </div>
          <div class="link-info">
            <span class="icon-tooltip-label link-label">
              <span class="text">转化指数</span>
              <span class="el-tooltip icon right"></span>
            </span>

            <div class="link-value">{{ exponentList?.length>2 ? exponentList[2]?.value:'-' }}</div>
          </div>
          <div class="rank">
            <span class="rank-label">行业排名</span>
            <div class="rank-value">{{ exponentList?.length>2 ?
                exponentList[2]?.rank<100 ? exponentList[2]?.rank:
                    handleRankPercent(exponentList[2]?.rank_percent) :'-' }}</div>
          </div>
        </div>

        <div class="tab-card-item link-card"
        :class="currentActiveTabIndex === 4?'is-active':''"
          @click="switchActiveCard(4)">
          <div class="relative-ratio">
            <span class="ratio-label">30天环比</span>
            <span class="ratio-value decline" v-if="!exponentList?.length>3">-</span>
            <span class="ratio-value decline" v-else
                  :class="exponentList[3]?.link_relative_ratio>0 ? 'colorRed':'colorGreen'">
                  {{exponentList[3]?.link_relative_ratio > 0?'+ ':''}}
              {{fmt(exponentList[3]?.link_relative_ratio*100, {micrometer: true})||'-'}}%
            </span>
          </div>
          <div class="link-info">
            <span class="icon-tooltip-label link-label">
              <span class="text">性价比指数</span>
              <span class="el-tooltip icon right"></span>
            </span>

            <div class="link-value">{{ exponentList?.length>3 ? exponentList[3]?.value:'-' }}</div>
          </div>
          <div class="rank">
            <span class="rank-label">行业排名</span>
            <div class="rank-value">{{ exponentList?.length>3 ?
                exponentList[3]?.rank<100 ? exponentList[3]?.rank:
                    handleRankPercent(exponentList[3]?.rank_percent) :'-' }}</div>
          </div>
        </div>

        <div class="tab-card-item link-card"
          :class="currentActiveTabIndex === 5?'is-active':''"
            @click="switchActiveCard(5)">
            <div class="relative-ratio">
              <span class="ratio-label">30天环比</span>
              <span class="ratio-value decline" v-if="!exponentList?.length>4">-</span>
              <span class="ratio-value decline" v-else
                    :class="exponentList[4]?.link_relative_ratio>0 ? 'colorRed':'colorGreen'">
                    {{exponentList[4]?.link_relative_ratio > 0?'+ ':''}}
                {{fmt(exponentList[4]?.link_relative_ratio*100, {micrometer: true})||'-'}}%
              </span>
            </div>
            <div class="link-info">
              <span class="icon-tooltip-label link-label">
                <span class="text">合作指数</span>
                <span class="el-tooltip icon right"></span>
              </span>

              <div class="link-value">{{ exponentList?.length>4 ? exponentList[4]?.value:'-' }}</div>
            </div>
            <div class="rank">
              <span class="rank-label">行业排名</span>
              <div class="rank-value">{{ exponentList?.length>4 ?
                  exponentList[4]?.rank<100 ? exponentList[4]?.rank:
                      handleRankPercent(exponentList[4]?.rank_percent) :'-' }}</div>
            </div>
        </div>
    </div>

    <div class="card-panel block-wrap" v-loading="loadingObj.trendChartInfo">
       <!-- 指数趋势 折线图  -->
        <div class="bigTitleBox">
         <span class="bigTitle">{{trendNames[currentActiveTabIndex]}}指数趋势</span>
        </div>
        <div class="base-chart">
          <Bar :info="trendChartInfo"></Bar>
        </div>
    </div>

    <div class="card-panel card-composite block-wrap" v-if="currentActiveTabIndex===0">
      <div class="bigTitleBox">
          <span class="bigTitle">商业能力</span>
      </div>
      <div class="sub-title"></div>
      <div class="linkInfoPart" v-loading="loadingObj.exponentList">
        <div>
            <div class="title">
                <h5>星图指数</h5>
                <i>{{linkInfo?.link_star_index?.value||''}}</i>
                <span :class="linkInfo?.link_star_index?.link_relative_ratio>0 ? 'colorRed':'colorGreen'">{{linkInfo?.link_star_index?.link_relative_ratio>0?'↑ ':'↓ '}}{{fmt(linkInfo?.link_star_index?.link_relative_ratio*100, {micrometer: true})||'-'}}%</span>
                <span style="margin-left:12px;color: #999;">行业内排名<span style="color:#333;font-weight: 600;margin-left: 5px;">{{handleRankPercent(linkInfo?.link_star_index?.rank_percent)||"-"}}</span></span>
            </div>
            <div class="radar_box">
                <Radar :info="starPicRadar" ref="part1Chart"></Radar>
            </div>
        </div>
        <div class="list_box">
          <div class="list_head">
              <span style="width:88px;text-align:center">指数名称</span><span style="width:88px;text-align:center">指数值</span><span style="width:88px;text-align:center">30天环比</span><span style="width:88px;text-align:center">行业均值</span><span style="width:88px;text-align:center">行业排名</span>
          </div>
          <div class="list_content">
              <div class="list_item" v-for="(item,index) in exponentList" :key="index">
                  <span style="width:88px;text-align:center">
                      {{ item.name }}
                  </span>
                  <span style="width:88px;text-align:center">{{ item.value }}</span>
                  <span v-if="item.link_relative_ratio==0" style="width:88px;text-align:center">持平</span>
                  <span v-else style="width:88px;text-align:center" :class="item.link_relative_ratio>0 ? 'color-orange':'color-green'">{{item.link_relative_ratio>0?"+":''}}{{fmt(item.link_relative_ratio*100, {micrometer: true})}}%</span>
                  <span style="width:88px;text-align:center">{{ fmt(item.avg_value, {micrometer: true})}}</span>
                  <span style="width:88px;text-align:center">{{ item.rank<100? item.rank : handleRankPercent(item.rank_percent)}}</span>
              </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 优秀传播视频展示  -->
    <div class="videoBoxPart" v-if="currentActiveTabIndex===1">
      <div class="videoHeader">
        <div class="leftTitle">优秀传播视频展示</div>
        <!-- <div class="rightBtn" @click="scrollToTab2Video">
          <i class="el-icon-arrow-right"></i>
          查看更多
        </div> -->
      </div>
      <div class="videoContent" v-loading="loadingObj.videoSpread">
        <ul>
          <li v-for="(item,i) in videoItems" :key="i">
            <div class="video" @click="e=>{videoClick(e,item)}" @mouseenter="e=>{videoMove(e,item)}" @mouseleave="e=>{videoOut(e,item)}">
              <div class="videoWrap"></div>
              <video muted :src="item.video_id" :vindex="i" :poster="item.img_id" preload="none"></video>
            </div>
            <p>{{item.title}}</p>
            <div class="tag">
              <i></i>
              <span>{{item.play}}</span>
              <i></i>
              <span>{{item.like}}</span>
              <i></i>
              <span>{{item.comment}}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 种草指数视频展示 -->
    <div class="videoBoxPart" v-if="currentActiveTabIndex===2">
      <div class="videoHeader">
        <div class="leftTitle">优秀种草视频展示</div>
        <!-- <div class="rightBtn" @click="scrollToTab2Video">
          <i class="el-icon-arrow-right"></i>
          查看更多
        </div> -->
      </div>
      <div class="videoContent" v-loading="loadingObj.videoShop">
        <ul>
          <li v-for="(item,i) in recommendVideoItems" :key="i">
            <div class="video" @click="e=>{videoClick(e,item)}" @mouseenter="e=>{videoMove(e,item)}" @mouseleave="e=>{videoOut(e,item)}">
              <div class="videoWrap"></div>
              <video muted :src="item.video_id" :vindex="i" :poster="item.img_id" preload="none"></video>
            </div>
            <p>{{item.title}}</p>
            <div class="tag">
              <i></i>
              <span>{{item.play}}</span>
              <i></i>
              <span>{{item.like}}</span>
              <i></i>
              <span>{{item.comment}}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 视频点击时的展示 -->
    <div v-if="alertShow.isShow" class="alertVideo" @click="closeClick">
      <div class="close" @click="closeClick"></div>
      <div class="videoCard" @click.stop>
        <div class="videoBox">
          <video autoplay controls loop :src="alertShow.src"></video>
        </div>
        <div class="videoInfo">
          <div class="videoInfoTop">
            <div class="photo"><img :src="darenInfo.avatar_uri" alt=""></div>
            <div class="name">
              <p> {{darenInfo.nick_name}}</p>
              <i>粉丝数</i><b>{{fmt(darenInfo.follower/10000, {micrometer: true})||'-'}}w</b>
            </div>
          </div>
          <div class="tag" v-for="(item,i) in darenInfo.tags_relation" :key="i">
            <span>{{i}}</span>
            <!-- <span>时尚是</span>
            <span>时尚</span> -->
          </div>
          <div class="hr"></div>
          <p> {{videoClickItem.title}} </p>
          <div class="other">
            <i></i><b>{{videoClickItem.play}}</b>
            <i></i><b>{{videoClickItem.like}}</b>
            <i></i><b>{{videoClickItem.comment}}</b>
          </div>
        </div>
        <div class="bottom">
          <a :href="videoClickItem.url" target="_blank">打开视频</a>
          <i v-clipboard:copy="videoClickItem.url" v-clipboard:success="onCopy">复制链接</i>
          <!-- <a href="javascript:void(0);" @click="copyUrl">复制链接</a> -->
        </div>

      </div>
    </div>

    <div class="card-panel card-convert block-wrap"  v-if="currentActiveTabIndex===3">
       <!-- 转化能力分析 -->
       <div class="bigTitleBox f_j_b">
          <span class="bigTitle">转化能力分析</span>
          <el-dropdown trigger="click" @command="timeTagsClick" >
            <span class="el-dropdown-link">
              {{ "时间:"+timeTagsData.name }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(item,index) in timeTags" :command="item" :key="index">{{item.name || '-'}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
      </div>
    <div class="zhzsPart-wrap" v-loading="loadingObj.zhzsPart">
      <div class="flex-box">
          <div class="data">
            <div class="label">相关视频数</div>
            <div class="value">{{authorConvertabilityData?.related_video_cnt?.value || '-'}}</div>
          </div>
          <div class="data">
            <div class="label">播放中位数</div>
            <div class="value">{{fmt(authorConvertabilityData?.video_vv_median?.value,{micrometer: true})||'-'}}</div>
          </div>
          <div class="data">
            <div class="label">组件点击量</div>
            <div class="value">{{authorConvertabilityData?.component_click_cnt_range || '-'}}</div>
          </div>
          <div class="data">
            <div class="label">组件点击率</div>
            <div class="value">{{authorConvertabilityData?.component_click_rate_range || '-'}}</div>
          </div>
          <div class="data">
            <div class="label">相关CPC</div>
            <div class="value">{{authorConvertabilityData?.related_cpc_range || '-'}}</div>
          </div>
      </div>
      <el-divider></el-divider>
      <div class="flex-box">
          <div class="data">
            <div class="label">带货商品数</div>
            <div class="value">{{authorConvertabilityData?.rec_product_cnt?.value|| '-'}}</div>
          </div>
          <div class="data">
            <div class="label">平均销售额区间</div>
            <div class="value">{{authorConvertabilityData?.avg_sales_amount_range|| '-'}}</div>
          </div>
          <div class="data">
            <div class="label">带货商品价格</div>
            <div class="value">{{authorConvertabilityData?.rec_product_price_range|| '-'}}</div>
          </div>
          <div class="data">
            <div class="label">GPM</div>
            <div class="value">{{authorConvertabilityData?.gpm_range|| '-' }}</div>
          </div>
      </div>
      <el-divider></el-divider>
      <div class="bigTitleBox" style="margin-bottom:0">
          <span class="bigTitle">抖音小店带货分析</span>
      </div>
      <el-table style="width: 100%" :data="authorCategoryData">
        <el-table-column prop="name" label="品类名称">
        </el-table-column>
        <el-table-column prop="sale_amount_range" label="销售额">
          <template slot-scope="scope">
            ￥{{scope.row.sale_amount_range}}
          </template>
        </el-table-column>
        <el-table-column label="销售额占比">
          <template slot-scope="scope">
            {{ fmt(scope.row.rate*100, {micrometer: true})}}%
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-divider></el-divider> -->
      <div class="flex-box author-ecomvideo-wrap">
        <h5 class="bigTitle">转换视频展示</h5>
        <el-radio-group v-model="authorEcomvideoDetailType" @change="detailTypeClick">
          <el-radio-button :label="1">相关视频数据</el-radio-button>
          <el-radio-button :label="2">相关商品数据</el-radio-button>
        </el-radio-group>
      </div>
    </div>
      <div class="" v-loading="loadingObj.videoTable">
        <el-table class="video-table"  v-if="authorEcomvideoDetailType==1" :data="authorEcomvideoData">
          <el-table-column width="200" label="视频信息" fixed="left">
            <template slot-scope="scope">
              <div class="flex-box">
                <div class="video-card-warp video-player">
                  <!-- <span>{{scope.row.item_stats}}</span> -->
                  <!-- <img style="width:50px;height:90px;" :src="'https://p3-tt.bytecdn.cn/obj/'+scope.row.item_stats.cover_uri"/> -->
                  <div class="video" @click="e=>{videoClick(e,scope.row)}"  @mouseenter="e=>{videoMove1(e)}" @mouseleave="e=>{videoOut1(e)}">
                    <div class="videoWrap1"></div>
                    <video style="width:50px;height:90px;" muted :src="'https://aweme.snssdk.com/aweme/v1/playwm/?video_id='+scope.row.item_stats.video_id+'&ratio=720p&line=0'" :poster="scope.row.item_stats.img_url" preload="none"></video>
                  </div>
                </div>
                <div class="message">
                  <div class="title text-ellipsis-l2">
                    <el-popover
                        placement="right"
                        title=""
                        width="250"
                        trigger="hover"
                        :content="scope.row.item_stats.title">
                        <div slot="reference">{{ scope.row.item_stats.title }}</div>
                      </el-popover>
                    </div>
                  <div class="time">发布时间：<span>{{ convertDate(scope?.row?.item_stats?.create_time)||"-"}}</span></div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="100" label="播放量">
            <template slot-scope="scope">
              {{ fmt(scope?.row?.item_stats?.stats?.watch_cnt, {micrometer: true})||"-" }}
            </template>
          </el-table-column>
          <el-table-column label="互动率">
            <template slot-scope="scope">
              {{ fmt(scope?.row?.item_stats?.stats?.interact_rate*100, {micrometer: true})||"-"}}%
            </template>
          </el-table-column>
          <el-table-column label="点赞">
            <template slot-scope="scope">
              {{ fmt(scope?.row?.item_stats?.stats?.like_cnt, {micrometer: true})||"-" }}
            </template>
          </el-table-column>
          <el-table-column label="评论">
            <template slot-scope="scope">
              {{ fmt(scope?.row?.item_stats?.stats?.comment_cnt, {micrometer: true})||"-"  }}
            </template>
          </el-table-column>
          <el-table-column label="转发">
            <template slot-scope="scope">
              {{ fmt(scope?.row?.item_stats?.stats?.share_cnt, {micrometer: true})||"-"  }}
            </template>
          </el-table-column>
          <el-table-column width="100" label="组件点击量">
            <template slot-scope="scope">
              {{ fmt(scope?.row?.component_click_cnt, {micrometer: true})||"-"  }}
            </template>
          </el-table-column>
          <el-table-column width="100" label="组件点击率">
            <template slot-scope="scope">
              {{ fmt(scope?.row?.click_rate*100, {micrometer: true})||"-"}}%
            </template>
          </el-table-column>
          <el-table-column label="营销额">
            <template slot-scope="scope">
              {{ fmt(scope?.row?.item_pay_amt, {micrometer: true})||"-" }}
            </template>
          </el-table-column>
          <el-table-column label="视频GPM">
            <template slot-scope="scope">
              {{ fmt(scope?.row?.gpm, {micrometer: true})||"-" }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="120" label="带货商品数">
            <template slot-scope="scope">
              {{ scope?.row?.prod_list? fmt(scope?.row?.prod_list?.length, {micrometer: true}) : 0 }}
            </template>
          </el-table-column>
        </el-table>
        <el-table class="video-table" v-if="authorEcomvideoDetailType==2" :data="authorEcomprodData.prod_list">
          <el-table-column label="商品信息" width="180px">
            <template slot-scope="scope">
              <div class="f_j_b">
                <img style="width:50px;height:50px;" :src="scope.row.prod_img"/>
                <div class="title text-ellipsis-l2">
                  <el-popover
                    placement="right"
                    title=""
                    width="250"
                    trigger="hover"
                    :content="scope?.row?.prod_name">
                    <div slot="reference">{{ scope?.row?.prod_name||"-"}}</div>
                  </el-popover>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="商品类目" prop="industry_category">
          </el-table-column>
          <el-table-column label="价格(￥)">
            <template slot-scope="scope">
              {{ fmt(scope?.row?.prod_price/1000, {micrometer: true} )||"-"}}
            </template>
          </el-table-column>
          <el-table-column label="关联视频数">
            <template slot-scope="scope">
              {{ scope?.row?.bind_item_cnt||"-" }}
            </template>
          </el-table-column>
          <el-table-column  label="销售额区间(￥)">
            <template slot-scope="scope">
            {{ scope?.row?.pay_amt_range ||"-" }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pages">
        <el-pagination
          @current-change="pageChange"
          :current-page.sync="pagination.curPage"
          :total="pagination.total_pages"
          :page-size="10"
          background
          layout="prev, pager, next, jumper">
        </el-pagination>
      </div>

    </div>

    <div class="card-panel card-cost-performance block-wrap" v-if="currentActiveTabIndex===4">
      <!-- 性价比分析 -->
      <div class="bigTitleBox">
          <span class="bigTitle">性价比分析</span>
      </div>
      <div class="sub-title"></div>
      <div class="flex-box" v-loading="loadingObj.authorCpinfoData">
        <div class="cost">
          <div class="head">
            <span class="title">性价比预估</span>
              <el-select size="small" popper-class="类型：" v-model="costType">
                <el-option label="1-20s视频" value="0"></el-option>
                <el-option label="20-60s视频" value="1" ></el-option>
                <el-option label="60s以上视频" value="2"></el-option>
                <el-option label="图文" value="3"></el-option>
              </el-select>
          </div>
          <div class="data-wrapper">
            <div class="data">
              <div class="label">预期CPM
                <el-tooltip content="基于达人预期播放量和当前报价计算的千次播放费用，仅作参考" placement="bottom">
                <i class="iconfont icon-19ad-icon-tooltip"></i>
              </el-tooltip>
              </div>
              <div class="value">{{getCPM()}}</div>
            </div>
            <div class="data">
              <div class="label">预期CPE
                <el-tooltip content="基于达人预期播放量、近期视频互动率和当前报价计算的单词点赞/评论/转发预估费用" placement="bottom" >
                <i class="iconfont icon-19ad-icon-tooltip"></i>
                </el-tooltip>
              </div>
              <div class="value">{{getCPE()}}</div>
            </div>
         </div>
        </div>
        <div class="cooperation">
          <div class="head">
            <span class="title">效果预估</span>
          </div>
         <div class="data-wrapper">
          <div class="data">
              <div class="label">预期播放量</div>
              <div class="value">{{changeW(authorCpinfoData?.expect_vv.value)||"-"}}w</div>
          </div>
          <div class="data">
            <div class="label">平台爆款率</div>
            <div class="value">{{authorCpinfoData?.hot_item?.value ? fmt(authorCpinfoData?.hot_item.value/100, {micrometer: true}) +'%':'-'}}</div>
          </div>
         </div>
        </div>
      </div>
    </div>

    <div class="card-panel card-cooperate block-wrap" v-if="currentActiveTabIndex===5">
      <!-- 合作能力分析 -->
      <div class="bigTitleBox">
          <span class="bigTitle">合作能力分析</span>
      </div>
      <div class="sub-title"></div>
      <div class="flex-box">
        <div class="data">
          <span class="label">合作行业数</span>
          <span class="value">{{coopDistributionData?.coop_industry_cnt||"-"}}</span>
        </div>
        <div class="data">
          <span class="label">合作商单数</span>
          <span class="value">{{darenCoope?.order_finish_cnt||"-"}}</span>
        </div>
        <div class="data">
          <span class="label">进行中任务数</span>
          <span class="value">{{darenCoope?.order_in_process_cnt||"-"}}</span>
        </div>
        <div class="data">
          <span class="label">信用分</span>
          <span class="value">{{darenCoope?.credit_score.value||"-"}}</span>
        </div>
      </div>
      <div class="card-cooperate-chart-wrap" v-loading="loadingObj.getCoopDistribution">
        <!-- 合作行业商单分析 饼图 -->
        <div class="chart-card triangle">
          <span class="title">合作行业商单分析</span>
          <div class="base-chart">
            <Pie :info="commercialChartInfo"></Pie>
          </div>
        </div>

        <!-- 合作行业播放量分析 饼图 -->
        <div class="chart-card">
          <span class="title">合作行业播放量分析</span>
          <div class="base-chart">
            <Pie :info="cooperateViewsChartInfo"></Pie>
          </div>
        </div>

      </div>
    </div>
 <!-- 相似达人模块-->
      <!-- <div class="part6" v-if="isShowSamedaren">
          <div class="bottemList">
            <div class="title">
                <div class="titleLeft"><i>{{darenName?darenName:''}}</i>相似达人推荐</div>
                <div style="display:none;" class="titleRight"><i class="reflesh"></i>刷新一下</div>
            </div>
            <ul class="sameList">
                <li v-for="(item,i) in sameDaren" :key="i">
                    <a :toHref="item.author_id" href="javascript:void(0);" @click="sameListClick">
                        <div class="top">
                            <div class="nameWrap">
                                <span>{{item.nick_name}}</span>
                                <div></div>
                                <i v-for="(u,v) in item.tags_content" :key="v">{{u}}</i>
                            </div>
                            <div class="imgWrap">
                                <img :src="item.avatar_uri" alt="">
                            </div>
                        </div>
                        <div class="center">
                            <div class="centerItem">
                                <span>{{(item.follower/10000).toFixed(1)}}w</span>
                                <p>粉丝数</p>
                            </div>
                            <div class="centerItem">
                                <span>{{item.expected_cpm}}</span>
                                <p>预期CPM</p>
                            </div>
                            <div class="centerItem">
                                <span>{{(item.author_score/10000).toFixed(1)}}</span>
                                <p>星图指数</p>
                            </div>
                        </div>
                        <div class="tag">
                            <span v-for="(x,b) in item.recommend_types" :key="b">{{x}}</span>
                        </div>
                        <div class="hr"></div>
                        <div class="bottem">
                            <span class="price">￥{{item.min_price}}</span>
                            <div class="other">
                                <i></i>详情
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
        </div>
      </div> -->
  </div>
</template>

<script>
import Bar from  "../../../components/newEchart/Bar.vue"
import Radar from '../../../components/newEchart/Radar.vue';
import Pie from "../../../components/newEchart/Pie.vue";
export default {
  name: "Capabilities",
  props:['darenName'],
  data(){
    return {
      exponentList:[],
      timeTags:[
        {id:1,name:'近7天'},
        {id:2,name:'近30天'},
        {id:3,name:'近90天'},
      ],
      timeTagsData:{id:3,name:'近90天'},
      // pageSameDarenRec:{},
        pageDarenCategory:{},
        pageDarenGoodsIndex30:{},
        pageDarenSpread22:{},
        pageDarenSpread12:{},
        pageDarenCoope:{},
        pageGetHotWord2:{},
        pageGetHotWord:{},
        pagelinkInfo:{},
        pageDarenInfo:{},
        //tab4Click是否是初始化
        isInitialize:true,
        //时间
      timeInfo:{
          day_1:'',
          day_7:'',
          day_30:'',
          day_90:''
      },
       //相似达人
      // sameDaren:{},
      // isShowSamedaren:false,
      // pageSameDarenRec:{},
      darenID:'',
      // 达人指数数据
      linkInfo:{},
      //大人热词
      hotWord:{},
      hotWord2:{},
      // 达人传播指数
      darenSpread:{},
      // 同类达人指数分析
      score_detail:{},
      // 达人任务
      darenCoope:{},
      // 带货平类
      darenCategory:{},
      //达人带货指数
      darenGoods:{},
      //预期数据
      expectData:{
          cpm:0,
          cpe:0
      },
      darenFans:{},
      tab1Position: '个人视频',
      tab2Position: '1-20s视频',
      tab4Position: '总量',
      guanxingIndexData:{//观星指数趋势图
        nodeId:'guanxingIndex',//节点
          data: [],//数据
        //   smooth:false,//平滑
          xAxisData:[],
        //   min:50, //y轴的最小值
        //   max:75, //y轴最大值
        //   interval:5, //值之间的间隔
        //   yAxisName: '',
        //   tooltipName:'',
        //   unit:''
      },
      hotwordEchartData:{//近30天评论热词
        nodeId:'hotwordEchart',//节点
        data: [],//数据
        color:["#ff5c00","#40a0fc"],
        xAxisData:[],
        min:0, //y轴的最小值
        max:500, //y轴最大值
        interval:100, //值之间的间隔
        yAxisName: '评论数',
        tooltipName:'评论数',
        unit:''//单位
      },
      addFansData:{//涨粉表现
          nodeId:'addFans',//节点
          data: [],//数据
          // smooth:true,//平滑
          xAxisData:[],
          //  min:35, //y轴的最小值
          //  max:50, //y轴最大值
          //  interval:5, //值之间的间隔
          //  yAxisName: '粉丝人数',
          //  tooltipName:'粉丝总量',
          unit:''
      },
      starPicData:{//星图指数
          nodeId:'starPic',//节点
          data: [],//数据
          max:[{text: '传播表现',value:'234', max: 100},{text: '涨粉表现 23',value:'234', max: 100},{text: '性价比表现 12',value:'234', max: 100},{text: '任务表现 123',value:'234', max: 100},{text: '种草表现 34',value:'234', max: 100}],
          data1:[],
          data2:[],
          formatter:function(params){
            return ('<div style="text-align:center;padding:0 8px;">虚线表示行业最低标准</div>')
          }
      },
      starPicRadar:{},
      part7Chart1Data:{//观星指数趋势图
        nodeId:'part7Chart1Node',//节点
        data: [],//数据
        //   smooth:false,//平滑
        xAxisData:[],
        //   min:50, //y轴的最小值
        //   max:75, //y轴最大值
        //   interval:5, //值之间的间隔
        yAxisName: '价格',
        //   tooltipName:'',
        unit:'',
        unit2:'￥',
      },
      part4Data:{
          addNum:"-",
          addDeg:"-",
      },
      flagPart:{
          flag1:false,
          flag2:true,
          flag3:true,
          flag4:true,
          flag5:true,
          flag6:true,
      },
    //   种草表现品类
      commerceData:{
          //设备分布
          nodeId: "commerceDataNode", //节点
          data: [{
              value: 18.5,
              name: "华为"
            }
          ], //数据
          color: ["#2074ff",
            "#38a1ff",
            "#77bfff",
            "#a7d6ff",
            "#d0e9ff",
            "#def0ff",],
          xAxisData: ["0-18"],
          min: 0, //y轴的最小值
          max: 60, //y轴最大值
          interval: 20, //值之间的间隔
          yAxisName: "占比",
          tooltipName: "占比",
          unit: "%",
          guideline: true, //引导线
      },
      commerceIsShow:true,

      // dododo
      currentActiveTabIndex: 0,
      industryClickDisabled: false,
      trendNames:["星图","传播","种草","转化","性价比","合作"],
      costType: "1",
      coopDistributionData:{},
      authorCpinfoData:{},
      authorEcomvideoData:[],
      // authorEcomprodData:{},
      convertDateRange: 3, // 默认2 1-7天 2-30天 3-90天
      authorEcomvideoDetailType: 1, // 默认1 1-相关视频 2-相关商品
      authorEcomvideoPage:1,
      authorCategoryData:[],
      authorConvertabilityData:{},
      authorEcomprodData:[],

      industry:[],//行业信息
      industryData:{
          category_id:0,
          category_name:'不限'
      },
      trendChartInfo:{},
      commercialChartInfo:{},
      cooperateViewsChartInfo:{},
      videoItems:[],
      videoClickItem:{},
      alertShow:{
        isShow:false,
        src:''
      },
      //达人播放数据
      darenInfo:{},
      recommendVideoItems:{},
      pagination: {
        total_pages: 10,
        curPage:1
      },
      loadingObj: {
        trendChartInfo: false,
        exponentList: false,
        videoTable: false,
        zhzsPart: false, //转化指数-转化能力分析等
        authorCpinfoData: false,
        videoSpread:false,
        videoShop:false,
      }
    }
  },
  computed:{

  },
  methods:{
    videoMove1(e,item){
        e.currentTarget.firstElementChild.className="videoWrap1 active"
        e.currentTarget.lastElementChild.play()
    },
    videoOut1(e,item){
        e.currentTarget.firstElementChild.className="videoWrap1"
        e.currentTarget.lastElementChild.pause()
    },
    pageChange(page){
      this.pagination.curPage = page
      this.getAuthorEcomvideo()
    },
    timeTagsClick(val){
      this.timeTagsData = val
      this.convertDateRange = val.id
    },
    // 优秀传播视频
    getAuthorVideoSpread(){
      this.loadingObj.videoSpread = true
      this.$api.getData.getAuthorVideoSpread(`/${this.darenID}?platform_channel=1&industry_id=${this.industryData.category_id}`).then((res) => {
        let data = res.data.data
        let videoItems = []
        data?.spread_videos?.forEach(function(item,i){
            let v={}
            // v:视频内容
            v.title=item.title
            v.comment=item.stats.comment_cnt
            v.play=item.stats.watch_cnt
            v.like=item.stats.favorite_cnt
            v.url=item.url
            v.video_id='https://aweme.snssdk.com/aweme/v1/playwm/?video_id='+item.video_id+'&ratio=720p&line=0'
            v.img_id='https://p3-tt.bytecdn.cn/obj/'+item.cover_uri
            if(v.like>=10000){
              v.like=(v.like/10000).toFixed(1)+'w'
            }
            if(v.play>=10000){
              v.play=(v.play/10000).toFixed(1)+'w'
            }
            if(v.comment>=10000){
              v.comment=(v.comment/10000).toFixed(1)+'w'
            }
            videoItems.push(v)
          })

        this.videoItems = videoItems
        this.loadingObj.videoSpread = false
      })
      .finally(() => {
        this.loadingObj.videoSpread = false
      })

    },
    // 优秀种草指数视频
    getAuthorVideoShop(){
      this.loadingObj.videoShop = true
      this.$api.getData.getAuthorVideoShop(`/${this.darenID}?platform_channel=1&industry_id=${this.industryData.category_id}`).then((res) => {
        let data = res.data.data
        let videoItems = []
        data?.shopping_videos?.forEach(function(item,i){
            let v={}
            // v:视频内容
            v.title=item.title
            v.comment=item.stats.comment_cnt
            v.play=item.stats.watch_cnt
            v.like=item.stats.favorite_cnt
            v.url=item.url
            v.video_id='https://aweme.snssdk.com/aweme/v1/playwm/?video_id='+item.video_id+'&ratio=720p&line=0'
            v.img_id='https://p3-tt.bytecdn.cn/obj/'+item.cover_uri
            if(v.like>=10000){
              v.like=(v.like/10000).toFixed(1)+'w'
            }
            if(v.play>=10000){
              v.play=(v.play/10000).toFixed(1)+'w'
            }
            if(v.comment>=10000){
              v.comment=(v.comment/10000).toFixed(1)+'w'
            }
            videoItems.push(v)
          })

        this.recommendVideoItems = videoItems
        this.loadingObj.videoShop = false
      })
      .finally(() => {
        this.loadingObj.videoShop = false
      })
    },
    videoClick(e,item){
      this.alertShow.isShow = true
      this.alertShow.src = item.video_id
      this.videoClickItem = item
    },
    videoMove(e,item){
      this.videoItems?.forEach(x=>{
        if(x.tagName == item.tagName){
          x.tagShow = false
        }
      })
      e.currentTarget.firstElementChild.className="videoWrap active"
      e.currentTarget.lastElementChild.play()
    },
    videoOut(e,item){
      this.videoItems?.forEach(x=>{
        if(x.tagName == item.tagName){
          x.tagShow = true
        }
      })
      e.currentTarget.firstElementChild.className="videoWrap"
      e.currentTarget.lastElementChild.pause()
    },
    closeClick(){
      this.alertShow.isShow=false
    },
    onCopy(){
      alert('复制链接成功')
    },
    sameListClick(e){
        let inSalesGroup=window.sessionStorage.getItem('inSalesGroup')
        let name=window.sessionStorage.getItem('name')
        window.sessionStorage.clear()
        window.sessionStorage.setItem('inSalesGroup',inSalesGroup)
        window.sessionStorage.setItem('name',name)
        let routeData = this.$router.resolve({
            path: '/daren',
          query: {
              id: e.currentTarget.getAttribute("tohref")
          }
        })
        window.open(routeData.href, "_blank");
    },
    handleRankPercent(rankPercent){
        if(!rankPercent){
            return "-%"
        }
        let newRankPercent = this.fmt(rankPercent*100, {micrometer: true})
        let finalResult = ""
        if(newRankPercent>0 && newRankPercent<0.5){
            finalResult = "前0.5%"
        }else if(newRankPercent>0.5 && newRankPercent<3){
            finalResult = "前3%"
        }else if(newRankPercent>3 && newRankPercent<10){
            finalResult = "前10%"
        }else if(newRankPercent>10 && newRankPercent<20){
            finalResult = "前20%"
        }else if(newRankPercent>20 && newRankPercent<50){
            finalResult = "前50%"
        }else if(newRankPercent>50 && newRankPercent<70){
            finalResult = "低于50%"
        }else if(newRankPercent>70 && newRankPercent<100 || newRankPercent < 0){
            finalResult = "低于70%"
        }
        return finalResult

    },
    getLinkInfo(){
      this.loadingObj.exponentList = true
        this.$api.getData.getLinkInfo(`/${this.darenID}?platform_channel=1&industy_tag=${this.industryData.category_id}`).then((res) => {
            window.sessionStorage.setItem('getLinkInfo',JSON.stringify(res));
            let data = res.data.data
            this.exponentList=[]
            let arr = ["传播指数","种草指数","转化指教","性价比指数","合作指数",]
            arr?.forEach(x=>{
                if(x=="传播指数"){
                    this.exponentList.push({name:x,...data.link_spread_index})
                }
                if(x=="种草指数"){
                    this.exponentList.push({name:x,...data.link_shopping_index})
                }
                if(x=="转化指教"){
                    this.exponentList.push({name:x,...data.link_convert_index})
                }
                if(x=="性价比指数"){
                    this.exponentList.push({name:x,...data.cp_index})
                }
                if(x=="合作指数"){
                    this.exponentList.push({name:x,...data.cooperate_index})
                }
            })
            // this.getAuthorIndustry()

            this.create2();
            // this.$refs.part1Chart.radarChart(this.starPicData)
        }).finally(() => {
          this.loadingObj.exponentList = false
        })
    },
    //获取行业信息
    async getAuthorIndustry(){
      await this.$api.getData.getAuthorIndustry().then((res) => {
          let data = res?.data?.data?.industry_categories

          this.industry = data?.map(x=>{
              return {category_id:x.category_id,category_name:x.category_name}
          })
          this.industry?.unshift({
              category_id:0,
              category_name:'不限'
          })
      })
    },
    //行业切换
    industryClick(val){
      this.industryData = val
    },
    async create2(){
        //   获取达人指数数据
        this.pagelinkInfo= JSON.parse(window.sessionStorage.getItem('getLinkInfo')).data.data;
        this.linkInfo = this.pagelinkInfo
        this.linkInfo.link_spread_index.value = this.pagelinkInfo.link_spread_index.value
        this.linkInfo.link_shopping_index.value = this.pagelinkInfo.link_shopping_index.value
        this.linkInfo.link_convert_index.value = this.pagelinkInfo.link_convert_index.value
        this.linkInfo.cp_index.value = this.pagelinkInfo.cp_index.value
        this.linkInfo.cooperate_index.value = this.pagelinkInfo.cooperate_index.value

        this.linkInfo.link_spread_index.avg_value = this.pagelinkInfo.link_spread_index.avg_value
        this.linkInfo.link_shopping_index.avg_value = this.pagelinkInfo.link_shopping_index.avg_value
        this.linkInfo.link_convert_index.avg_value = this.pagelinkInfo.link_convert_index.avg_value
        this.linkInfo.cp_index.avg_value = this.pagelinkInfo.cp_index.avg_value
        this.linkInfo.cooperate_index.avg_value = this.pagelinkInfo.cooperate_index.avg_value
        // this.linkInfo.top_score = this.changeW(this.pagelinkInfo.top_score)
        // this.linkInfo.link_spread_index.value  = this.changeW(this.pagelinkInfo.link_spread_index.value)
        // this.linkInfo.link_shopping_index.value  = this.changeW(this.pagelinkInfo.link_shopping_index.value)
        // this.linkInfo.link_convert_index.value  = this.changeW(this.pagelinkInfo.link_convert_index.value)
        // this.linkInfo.cp_index.value  = this.changeW(this.pagelinkInfo.cp_index.value)
        // this.linkInfo.cooperate_index.value  = this.changeW(this.pagelinkInfo.cooperate_index)

        // this.linkInfo.link_spread_index.avg_value = this.changeW(this.pagelinkInfo.link_spread_index.avg_value)
        // this.linkInfo.link_shopping_index.avg_value = this.changeW(this.pagelinkInfo.link_shopping_index.avg_value)
        // this.linkInfo.link_convert_index.avg_value = this.changeW(this.pagelinkInfo.link_convert_index.avg_value)
        // this.linkInfo.cp_index.avg_value = this.changeW(this.pagelinkInfo.cp_index.avg_value)
        // this.linkInfo.cooperate_index.avg_value = this.changeW(this.pagelinkInfo.cooperate_index.avg_value)
        this.starPicRadar = {
            name: '',
            data: [
                {
                    value: [],
                    name: '达人指数',
                    itemStyle:{
                        color:'#59B1FF'
                    }
                },
                {
                    value: [],
                    name: '行业均值',
                    itemStyle:{
                        color:'#ff5c00'
                    }
                },
            ],
            indicator: [
                {
                    name: '传播指数',
                    max: 100,
                    min:0,
                },
                {
                    name: '合作指数',
                    max: 100,
                    min: 0,
                },
                {
                    name: '性价比指数',
                    max: 100,
                    min: 0,
                },
                {
                    name: '转化指数',
                    max: 100,
                    min: 0,
                },
                {
                    name: '种草指数',
                    max: 100,
                    min: 0,
                },
                ],
                custom:{
                    legend: {
                        show: true,
                        itemWidth: 8,
                        itemHeight: 8,
                        top: 0,
                        left: 0,
                        orient: 'horizontal',
                        textStyle: {
                            fontSize: 12,
                            color: 'color',
                            borderRadius:50
                        },
                    },

                }
        }
        let data1= [this.linkInfo.link_spread_index.value, this.linkInfo.cooperate_index.value, this.linkInfo.cp_index.value, this.linkInfo.link_convert_index.value, this.linkInfo.link_shopping_index.value,]
        let data2= [this.linkInfo.link_spread_index.avg_value, this.linkInfo.cooperate_index.avg_value, this.linkInfo.cp_index.avg_value, this.linkInfo.link_convert_index.avg_value, this.linkInfo.link_shopping_index.avg_value]
        let data = {}
        data.data1 = data1
        data.data2 = data2
        this.starPicRadar.data = this.starPicRadar?.data?.map((x,i)=>{
            x.value = data[`data${i+1}`]
            return x
        })
    },

    // dododo
    switchActiveCard(index){
      this.currentActiveTabIndex = index;
      // 性价比指数和合作指数禁止切换行业
      if(index === 4 || index === 5){
        this.industryClickDisabled =  true;
      }else{
        this.industryClickDisabled = false;

      }
      if(index == 1){
        this.getAuthorVideoSpread()
      }
      if(index == 2){
        this.getAuthorVideoShop()
      }
      if(index==3){
        this.pagination.total_pages=10
        this.pagination.curPage=1
        this.getAuthorEcomvideo()
        this.getAuthorConvertability()
      }
      if(index == 5){
        this.getCoopDistribution()
      }

      // 星图指数显示商业能力
      this.getLinkDailyScore();
    },

    convertDateRangeParam(){
      switch(this.convertDateRange){
        case 1: return 7;
        case 2: return 30;
        case 3: return 90;
        default: return 30;
      }
    },

    getLinkDailyScore(){
      this.loadingObj.trendChartInfo = true
      this.$api.getData.getLinkDailyScore(`/${this.darenID}?platform_channel=1&industry_id=${this.industryData.category_id}&link_score_type=${this.convertActive()}`)
      .then((res) => {
        let linkDailyScore = res?.data?.data?.link_score_daily_cnt
        let options = {
         xAxis: linkDailyScore?.map(x=>x?.date?.substring(5))||[],
         data:[
          {
            name:`${this.trendNames[this.currentActiveTabIndex]}指数`,
            data:linkDailyScore?.map(x=>x?.value),
            type:"line",
            smooth: true,
            symbol: "none",
            color:"#38a1ff",
            areaStyle: {
              color: '#ccc',
              opacity: 0.1,
              shadowColor: '#38a1ff',
              shadowBlur: 10
            }
          }],
          custom: {
            grid: {
            bottom: 20
          },
            tooltip: {
            trigger: 'axis'
            },
            dataZoom: [
              {
              type:'inside',
              height:10,
              },
              {
                start: 0,
                end: 100,
                bottom: 0,
                height: 20,
                fillerColor: '#3377FF',
                backgroundColor: "#E8EBF3",
                showDetail: true,
              }
            ],
            yAxis: [
            {
              type: 'value',
              name: `${this.trendNames[this.currentActiveTabIndex]}指数`,
              max:Math.max.apply(null,linkDailyScore?.map(x=>x?.value)),
              min:Math.min.apply(null,linkDailyScore?.map(x=>x?.value)),
            }],
            xAxis:{
            axisLabel:{
              interval:20
            }
          },
          }
        }
        this.trendChartInfo = options
      }).finally(x => {
        this.loadingObj.trendChartInfo = false
      })
    },

     //   获取达人任务数据
    getDarenCoope(){
      if(window.sessionStorage.getItem('getDarenCoope')){
              this.pageDarenCoope= JSON.parse(window.sessionStorage.getItem('getDarenCoope')).data.data
              this.darenCoope = this.pageDarenCoope
      }else{
          this.$api.getData.getDarenCoope('/'+this.darenID).then((res) => {
              window.sessionStorage.setItem('getDarenCoope',JSON.stringify(res));
              this.darenCoope = res.data.data
          })
      }
    },

    //   合作行业商单分析
    async getCoopDistribution(){
      this.loadingObj.getCoopDistribution = true
      if(window.sessionStorage.getItem('getCoopDistribution')){
              this.coopDistributionData = JSON.parse(window.sessionStorage.getItem('getCoopDistribution'))?.data?.data
              this.updatePieChart()
      }else{
          await this.$api.getData.getCoopDistribution('/'+this.darenID).then((res) => {
              window.sessionStorage.setItem('getCoopDistribution',JSON.stringify(res));
              this.coopDistributionData = res.data.data
              this.updatePieChart()
          })
      }
      this.loadingObj.getCoopDistribution = false
    },

    // 性价比能力分析
    async getAuthorCpinfo(){
      this.loadingObj.authorCpinfoData = true
      if(window.sessionStorage.getItem('getAuthorCpinfo')){
          this.authorCpinfoData = JSON.parse(window.sessionStorage.getItem('getAuthorCpinfo')).data.data
      }else{
          await this.$api.getData.getAuthorCpinfo('/'+this.darenID).then((res) => {
              window.sessionStorage.setItem('getAuthorCpinfo',JSON.stringify(res));
              this.authorCpinfoData = res.data.data || {}
          })
      }
      this.loadingObj.authorCpinfoData = false
    },

    //   获得转换视频
    getAuthorEcomvideo(){
      this.loadingObj.videoTable = true
      let detailType = this.authorEcomvideoDetailType;
      this.$api.getData.getAuthorEcomvideo(`/${this.darenID}?platform_channel=1&range=${this.convertDateRange}&detail_type=${this.authorEcomvideoDetailType}&industry_id=${this.industryData.category_id}&page=${this.pagination.curPage}`)
      .then((res) => {
              if(detailType == 1){
                this.authorEcomvideoData = res?.data?.data?.video_list
                this.authorEcomvideoData && this.authorEcomvideoData?.forEach(x=>{
                  x.video_id='https://aweme.snssdk.com/aweme/v1/playwm/?video_id='+x.item_stats.video_id+'&ratio=720p&line=0'
                  x.title = x.item_stats.title
                  x.comment=x.item_stats.stats.comment_cnt
                  x.play=x.item_stats.stats.watch_cnt
                  x.like=x.item_stats.stats.favorite_cnt
                  x.url=x.item_stats.url
                  this.$api.getData.getAuthorUri(`?uri=${x.item_stats.cover_uri}`).then(res=>{
                    x.img_url = res.data.mainURL
                  })

                })
                this.pagination.total_pages = res.data.data.pagination.total_count
              }else{
                this.authorEcomprodData = res.data.data
                this.pagination.total_pages = res.data.data.pagination.total_count
              }
          }).finally(() => {
            this.loadingObj.videoTable = false
          })
    },




     //   获取账号转化能力分析
     getAuthorConvertability(){
      this.loadingObj.zhzsPart = true
      this.$api.getData.getAuthorConvertability(`/${this.darenID}?platform_channel=1&industry_id=${this.industryData.category_id}&range=${this.convertDateRange}`)
      .then((res) => {
          //   抖音小店带货排行
            this.authorCategoryData = res?.data?.data?.category_items||[]
            //转化能力分析
            this.authorConvertabilityData = res?.data?.data || {}
          }).finally(() => {
            this.loadingObj.zhzsPart = false
          })
    },

    updatePieChart(){
      let industry_order_infos = this.coopDistributionData?.coop_industry_order_infos || []
      let coop_industry_vv_infos = this.coopDistributionData?.coop_industry_vv_infos || []
      let color = ['#1C7CFC','#3E92FF','#42A6FE','#73C2FF','#88CBFF']
      this.commercialChartInfo = {
        name:"合作行业商单分析",
        radius: ['45%', '60%'],
        showLabelRate: 4, //比率大于百分之5的时候展示label
        showPercent:false,
        data: [ ],
        custom: {
          selectedMode:'single',
          grid:{
            left:20,
            right:20,
          },
          tooltip: {
            show:true,
            trigger: 'item',
            formatter: '{b}:{d}%'
          },
          legend: {
            show:false
          },
          series: [
            {
              label: {
                show: true,
                formatter: '{b}\n{d}%',
                bleedMargin:"10%"
              },
              labelLine:{
              show:true,
              length:10,
              length2:10
              },
            }
          ]
        }
      }
      this.cooperateViewsChartInfo = {
        name:"合作行业播放量分析",
        radius: ['45%', '60%'],
        showLabelRate: 4, //比率大于百分之5的时候展示label
        showPercent:false,
        data: [ ],
        custom: {
          grid:{
            left:20,
            right:20,
          },
          tooltip: {
            show:true,
            trigger: 'item',
            formatter: '{b}:{d}%'
          },
          legend: {
            show:false
          },
          series: [
            {
              label: {
                show: true,
                formatter: '{b}\n{d}%',
                bleedMargin:"10%"
              },
              labelLine:{
              show:true,
              length:10,
              length2:10
             },
            }
          ]
        }
      }
      this.commercialChartInfo.data = industry_order_infos?.map((d,i)=>{
          return {value: d.proportion, name:d.name, color:color[i]}
        })
      this.cooperateViewsChartInfo.data = coop_industry_vv_infos?.map((d,i)=>{
          return {value: d.proportion, name:d.name, color:color[i]}
        })

    },

    detailTypeClick(){
      this.pagination.total_pages=10
      this.pagination.curPage=1
      this.getAuthorEcomvideo();
    },

    getVideoTablePage(){
      if(this.authorEcomvideoDetailType == 1){
        return this.authorEcomvideoData.pagination ? this.authorEcomvideoData.pagination.total_count:0
      }else{
        return this.authorEcomprodData.pagination ? this.authorEcomprodData.pagination.total_count:0
      }
    },

    // 转换接口参数
    convertActive(){
      switch(this.currentActiveTabIndex){
        case 0: return 1;
        case 1: return 2;
        case 2: return 6;
        case 3: return 5;
        case 4: return 3;
        case 5: return 4;
      }
    },

    changeW(num){
       return (num/10000).toFixed(1)
    },

    getCPM(){
      switch(this.costType){
        case '0':  return this.fmt(this.authorCpinfoData?.expect_cpm.cpm_1_20/100,{micrometer: true})||"-";
        case '1':  return this.fmt(this.authorCpinfoData?.expect_cpm.cpm_21_60/100,{micrometer: true})||"-";
        case '2':  return this.fmt(this.authorCpinfoData?.expect_cpm.cpm_60/100,{micrometer: true})||"-";
        default: return '-'
      }
    },

    getCPE(){
      switch(this.costType){
        case '0':  return this.fmt(this.authorCpinfoData?.expect_cpe.cpe_1_20/100,{micrometer: true})||"-";
        case '1':  return this.fmt(this.authorCpinfoData?.expect_cpe.cpe_21_60/100,{micrometer: true})||"-";
        case '2':  return this.fmt(this.authorCpinfoData?.expect_cpe.cpe_60/100,{micrometer: true})||"-";
        default: return '-'
      }
    },
    // create10(){
    //   this.sameDaren = this.pageSameDarenRec
    //   if(this.sameDaren){
    //       this.sameDaren.forEach(function(item){
    //           item.author_id =item.author_id
    //       })
    //       this.isShowSamedaren = true
    //   }
    // },
    convertDate(timestamp){
      var date = new Date(timestamp*1000);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();

      return year + '-' + month + '-' + day
    }
  },
  components:{
    Bar,
    Radar,
    Pie
  },
  watch:{
    "industryData.category_id":{
        handler(val){
          this.getLinkInfo()
          this.getLinkDailyScore()
          this.pagination.total_pages=10
          this.pagination.curPage=1
          this.getAuthorEcomvideo()
          this.getAuthorConvertability()
          this.getCoopDistribution()
          if(this.currentActiveTabIndex == 1){
            this.getAuthorVideoSpread()
          }else if(this.currentActiveTabIndex == 2){
            this.getAuthorVideoShop()
          }
          // this.getAuthorIndustry()
        },
    },
    "timeTagsData.id":{
        handler(val){
          this.getAuthorConvertability()
          this.pagination.total_pages=10
          this.pagination.curPage=1
          this.getAuthorEcomvideo()
        },
    }
  },
  created(){
    this.darenID = this.$route.query.id
    this.getAuthorIndustry()
    this.getLinkInfo()
    this.getLinkDailyScore()
    this.getDarenCoope()
    this.getAuthorCpinfo()
    this.getAuthorEcomvideo()
    this.getAuthorConvertability()
    this.getCoopDistribution()
    this.getAuthorVideoSpread()
    this.getAuthorVideoShop()
    this.darenInfo = JSON.parse(window.sessionStorage.getItem('getDarenInfo')).data.data
      //  获取相似达人推荐
  // if(window.sessionStorage.getItem('getDarenCoope')){
  //       this.pageSameDarenRec= JSON.parse(window.sessionStorage.getItem('getSameDarenRec')).data.data
  //       this.create10()
  //   }else{
  //       this.$api.getData.getSameDarenRec('/'+this.darenID).then((res) => {
  //           window.sessionStorage.setItem('getSameDarenRec',JSON.stringify(res));
  //           this.pageSameDarenRec= JSON.parse(window.sessionStorage.getItem('getSameDarenRec')).data.data
  //           this.create10()
  //       })
  //   }

  },
  mounted() {
    let _this = this
    //监听键盘Esc按键事件
    this.$nextTick(function() {
      // 按下键盘
      document.addEventListener('keydown', function(e) {
        // Esc按键是27
        if (e.keyCode == 27) {
          //在这里写你的操作逻辑
          _this.closeClick()
        }
      });
    });
  }
}
</script>


<style lang="less" scoped>
    .el-dropdown-menu{
      max-height: 350px;
      overflow: auto;
    }
    /deep/.el-pagination .btn-next .el-icon{
      text-align: center !important;;
    }
</style>

<style scoped>
.pages{
  display: flex;
  justify-content: flex-end;
}
.f_j_b{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
  /* 粉丝趋势折线图 */
  #fansNum{
    width: 100%;
    height: 288px;
  }

  #trendChart{
    width: 100%;
    height: 100%;
  }

  #commercialChart{
    width: 100%;
    height: 100%;
  }

  #cooperateViewsChart{
    width: 100%;
    height: 100%;
  }
  .portrait .hr{
    width: 804px;
    height: 0.5px;
    margin-top: 24px;
    margin-left: 30px;
    background: #F0F0F0;
  }
  .portrait .summary{
    border-top: 1px solid #F0F0F0;
    width: 802px;
    margin-left: 30px;
    margin-top: 24px;
  }
  .portrait .summary i{
    display: block;
    height: 70px;
    line-height: 70px;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .portrait .summary span{
    margin-right: 36px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
  }
  .portrait .summary span:nth-of-type(1){
    margin-left: 9px;
  }

  /* todo */
  .capabilities .author-ecomvideo-wrap{
    justify-content: space-between;
  }
  .capabilities .dispatchWarp{
    padding:0 24px 24px 24px;
    box-sizing: border-box;
    width: 100%;
    height: 440px;
    border-radius: 6px;
    background: #FFFFFF;
  }

  .card-panel{
    width: 100%;
    padding: 0 30px 30px 30px;
    background: #FFFFFF;
    border-radius: 6px;
    box-sizing: border-box;
    margin-top: 16px;
  }

  .base-chart {
      width: 100%;
      height: 300px;
  }
  .card-head{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 34px;
    margin-bottom: 10px;
  }

  .card-head-right{
    display: inline-block;
    position: relative;
  }

  .card-head .title {
    font-weight: 500;
    font-size: 16px;
    line-height: 34px;
  }

  .tab-card-group{
    display: flex;
    flex-wrap: nowrap;
  }

  .tab-card-item:first-child {
    width: 232px;
    border-radius: 8px;
  }

  .tab-card-item{
    position: relative;
    padding: 12px;
    border: 1px solid transparent;
    background: #FFFFFF;
    cursor: pointer;
  }

  .tab-card-item:hover {
      z-index: 1;
      box-shadow: 0 0 15px rgba(0,0,0,.1);
  }

  .tab-card-item:not(:first-child), .tab-card-item[data-v-a8d337c3]:not(:last-child) {
    border-right: 1px solid #F0F0F0;
  }

  .tab-card-item:not(:first-child) {
    flex: 1;
  }

  .tab-card-item:nth-child(2) {
    margin-left: 12px;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  .tab-card-item.is-active {
    border-color: #ff5c00;
  }

  .link-card .relative-ratio {
    display: flex;
    justify-content: flex-end;
    font-size: 12px;
    line-height: 20px;
  }

  .link-card .link-info{
    margin-top: 20px;
    color: #333;
  }
  .link-card .link-info .link-label {
    font-weight: 500;
    font-size: 13px;
    line-height: 22px;
  }

  .icon-tooltip-label{
      display: inline-flex;
      align-items: center;
      vertical-align: middle;
  }

  .link-card .link-info .link-value {
      font-family: OPPOSans;
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
  }

  .link-card .relative-ratio .ratio-label {
    color: #c1c1c1;
    font-weight: 400;
  }

  .link-card .relative-ratio .ratio-value {
      margin-left: 2px;
      font-weight: 500;
  }

  .link-card .relative-ratio .decline {
      color: #0bb55a;
  }
  .capabilities .tab-card-item {
      height: 138px;
  }

  .capabilities .tab-card-item:first-child {
      width: 156px;
  }

  .link-card .rank {
      margin-top: 4px;
  }
  .link-card .rank-label {
      color: #c1c1c1;
      font-weight: 400;
      font-size: 12px;
      line-height: 20px;
  }

  .link-card .rank-value {
      margin-left: 2px;
      color: #666;
      font-weight: 500;
      font-size: 12px;
      line-height: 20px;
  }

  .list_box{
      flex: 1;
      width: 440px;
      font-size: 12px;
      font-family: OPPOSans;
      color: #333333;
  }
  .list_box .Block{
      display: block;
      width: 12px;
      height: 12px;
      border-radius: 4px;
  }
  .list_head,.list_item{
      display: flex;
      justify-content:space-between;
      padding: 18px 0;
      border-bottom: 1px solid #EFF1F1;

  }
  .list_head{
      color: #666;
      background-color: #FAFAFA;
  }
  .bigTitleBox{
        padding: 24px 0;
        border-bottom: 1px solid #F0F0F0;
        margin-bottom: 24px;
    }
  .bigTitle{
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
  }
  .radar_box{
    margin-top: 16px;
    width: 378px;
    height: 310px;
  }
  .colorRed{
      margin-left: 8px;
      font-size: 12px;
      color: #ff5c00 !important;
  }
  .colorGreen{
      margin-left: 8px;
      font-size: 12px;
      color: #43D4B9 !important;
  }

  .capabilities .card-composite{
      padding:0 24px 24px 24px;
      box-sizing: border-box;
      width: 100%;
      height: 440px;
      border-radius: 6px;
      background: #FFFFFF;
  }
  .capabilities .card-composite .linkInfoPart{
      height: 100%;
      display: flex;
      justify-content: space-around;
  }
  .capabilities .card-composite .linkInfoPart:nth-of-type(2){
      border-right: 0;
  }
  .capabilities .card-composite .linkInfoPart.linkInfoPart2 .title i{
      float: right;
      color: #38A1FF;
  }
  .capabilities .card-composite .linkInfoPart .title{
      display: flex;
      width: 100%;
      height: 16px;
      /* padding: 0 30px; */
      box-sizing: border-box;
  }
  .capabilities .card-composite .linkInfoPart .title h5{

      margin: 0;
      line-height: 16px;
      font-size: 16px;
      font-family: OPPOSans;
      font-weight: 400;
      color: #333333;
  }
  .capabilities .card-composite .linkInfoPart .title i{

      margin-left: 16px;
      line-height: 16px;
      font-size: 18px;
      font-family: OPPOSans;
      font-weight: bold;
      color: #ff5c00;
  }
  .capabilities .card-composite .linkInfoPart .title span{

      line-height: 16px;
      font-size: 14px;
      font-family: OPPOSans;
      font-weight: 400;
      cursor: pointer;
  }
  .linkInfoPart .rank{
      width: 100%;
      height: 100px;
      margin-top: 20px;
      padding-bottom: 23px;
      box-sizing: border-box;
      border-bottom: 1px solid #F0F0F0;
  }
  .linkInfoPart .rank .rankItem{
      display: inline-block;
      width: 50%;
      height: 100%;
      padding: 0 30px;
      border-right: 1px solid #F0F0F0;
      box-sizing: border-box;
  }
  .linkInfoPart .rank .rankItem:nth-of-type(2){
      border: 0;
  }
  .linkInfoPart .rank .rankItem span{
      font-size: 12px;
      font-family: OPPOSans;
      font-weight: 400;
      color: #333333;
  }
  .linkInfoPart .rank .rankItem i{
      display: block;
      margin: 10px 0;
      font-size: 16px;
      font-family: OPPOSans;
      font-weight: bold;
      color: #333333;
  }
  .linkInfoPart .rank .rankItem p{
      font-size: 12px;
      font-family: OPPOSans;
      font-weight: 500;
      color: #999999;
  }
  .linkInfoPart .rank .rankItem u{
      display: inline-block;
      margin: 0 4px;
      color: #FF5C00;
      text-decoration: none;
  }

  .linkInfoPart h5{
      padding-left: 20px;
      font-size: 16px;
      font-family: OPPOSans;
      font-weight: 400;
      color: #333333;
      box-sizing: border-box;
  }

  .card-composite .linkInfoPart .title h5{
      padding-left: 0;
  }



  .card-cost-performance .cost{
    padding-right: 24px;
  }

  .card-cost-performance .cost .head{
    display: flex;
    justify-content: space-between;
  }

  .card-cost-performance .head{
    margin-bottom: 24px
  }
  .card-convert{
    padding: 30px;
  }
  .card-cost-performance .data, .card-convert .data{
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;
      width: 50%;
      text-align: center;
  }
  .card-cost-performance .value,.card-convert .value {
      text-align: center;
      margin: 10px 0;
  }

  .card-cost-performance .data-wrapper,.card-convert .data-wrapper{
      display: flex;
  }

  .card-cost-performance .data .label, .card-convert .data .label{
    margin: 0 auto;
    padding-bottom: 4px;
    color: #999;
    font-size: 14px;
    line-height: 18px;
  }

  .card-cost-performance .title{
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
  }

  .card-cost-performance .cost, .card-cost-performance .cooperation {
      position: relative;
      width: 50%;
  }
  .card-cost-performance .flex-box .icon-19ad-icon-tooltip{
    font-size: 14px;
    margin-left:5px;

  }
  .card-cost-performance .flex-box .icon-19ad-icon-tooltip:hover{
    color: #666;
    cursor: pointer;
  }

  .flex-box{
    display: flex;
    align-items: center;
  }


  .card-cooperate .data{
    position: relative;
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .flex-box .data{
    border-right: 1px solid #F0F0F0;
  }
  /* .flex-box .data:after{
    content:"";
    display:block;
    margin-top: 0;
    margin-right: 0;
    width: 1px;
    height: 50px;
    background-color:#F0F0F0;
  } */

  .card-cooperate .data .label{
    color: #999;
    font-size: 14px;
    line-height: 22px;
  }

  .card-cooperate .data .value{
    color: #333;
    font-family: OPPOSans-Cloak;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
  }

  .card-cooperate-chart-wrap{
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
  }

  .card-cooperate-chart-wrap .chart-card{
    width: 50%;
    height: 321px;
    margin: 24px 0;
    border-top:1px solid #F0F0F0;
    padding-top: 20px;
  }

  .card-cooperate-chart-wrap .chart-card .base-chart{
    height: 300px;
  }

  .card-cooperate-chart-wrap .chart-card .title{
      margin-left: 20px !important;
      color: #333;
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
  }
  .card-cooperate-chart-wrap .chart-card .chart-header {
      display: flex;
      justify-content: space-between;
  }

  .card-cooperate-chart-wrap .chart-card .chart-header .selected-name {
      color: #666;
      font-weight: 400;
      font-size: 12px;
      line-height: 22px;
  }

  .card-cooperate-chart-wrap .chart-card .base-chart {
      height: 280px;
  }
  .card-cooperate-chart-wrap .triangle {
      position: relative;
      border-right: 1px solid #F0F0F0;
  }

  .video-table{
    width: 100%
  }

  .video-table .video-card-warp{
    width: 50px;
  }

  .video-table .message{
    width: 140px;
    margin-left: 12px;
    font-family: PingFang SC;
  }

  .video-table .message{
    width: 140px;
    margin-left: 12px;
    font-family: PingFang SC;
  }

  .video-table .message .title {
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
  }

  .video-table .video-player {
      width: 50px;
      height: 90px;
      margin: 0;
      overflow: hidden;
      border-radius: 8px;
      cursor: pointer;
  }
  .video-player .video-player-placeholder{
      width: 100%;
      padding-top: 137.5%;
  }

  .video-table .message .time{
      margin-top: 4px;
      color: #666;
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
  }

  .text-ellipsis-l2 {
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
  }

  .analysisPart{
    width: 100%;
    height: 396px;
    padding: 0 30px;
    background: #FFFFFF;
    border-radius: 6px;
    box-sizing: border-box;
    margin-top: 16px;
  }
  .capabilities .top{
    width: 100%;
    height: 76px;
    box-sizing: border-box;
    border-bottom: 1px solid #F0F0F0;
  }
  .capabilities .top h5{
    display: inline-block;
    height: 76px;
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .capabilities .top i{
    display: inline-block;
    margin-left: 10px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #999999;
  }
  .capabilities .top .tab{
    float: right;
    margin-left: 16px;
    margin-top: 22px;
  }
  .capabilities>>>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
    color: #FF5C00;
    background-color: #FFF2EB;
    border-color: #FF5C00;
    box-shadow: -1px 0 0 0 #FF5C00;
  }
  .capabilities>>>.el-radio-button__inner:hover{
    color: #333;
  }
  .capabilities>>>.el-radio-button__inner{
    padding: 10px 16px;
  }
  .capabilities>>>.el-radio-button:first-child .el-radio-button__inner{
    border-radius: 2px 0 0 2px;
  }
  .capabilities>>>.el-radio-button:last-child .el-radio-button__inner{
    border-radius: 0 2px 2px 0;
  }

  .capabilities .portrait>>>.el-tabs__content{
    margin-top: 0;
  }
  .capabilities .portrait>>>.el-tabs__nav-wrap::after{
    height: 0;
  }
  .capabilities .portrait>>>.el-tabs__nav-scroll{
    padding-left: 30px;
  }
  .capabilities .portrait{
    width: 100%;
    margin-top:16px;
    background: #FFFFFF;
    border-radius: 6px;
  }
  .capabilities .portrait>>>.el-tabs__item{
    line-height:74px;
    font-size: 18px;
    font-family: OPPOSans;
    font-weight: 400;
    color: #333333;
  }
  .capabilities .portrait>>>.el-tabs__active-bar{
    background:transparent!important;
  }
   /*达人推荐 */

   .capabilities .part6{
        margin-top: 16px;
    }

    .bottemList {
        width: 864px;
        padding: 0 28px;
        background: #FFFFFF;
        border-radius: 6px;
        box-sizing: border-box;
    }

    .bottemList .title {
        width: 100%;
        height: 74px;
        font-size: 16px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #333333;
        line-height: 74px;
    }

    .bottemList .title .titleLeft {
        float: left;
        height: 100%;
    }

    .bottemList .title .titleLeft i {
        color: #FF5500;
    }

    .bottemList .title .titleRight {
        position: relative;
        float: right;
        color: #666666;
        height: 100%;
    }

    .bottemList .title .titleRight .reflesh {
        position: absolute;
        top: 0;
        bottom: 0;
        left: -22px;
        margin: auto 0;
        width: 16px;
        height: 16px;
        background: url("../images/icon_updata.png");
    }

    .bottemList .sameList {
        width: 100%;
        margin-top: 0;
        padding: 0;
        overflow: hidden;
    }

    .bottemList .sameList .top {
        width: 100%;
        height: 54px;
        margin-bottom: 0;
        border: 0;
    }

    .bottemList .sameList li {
        float: left;
        width: 248px;
        height: 264px;
        margin-right: 30px;
        margin-bottom: 30px;
        padding: 24px;
        background: #FFFFFF;
        border: 1px solid #E8E8E8;
        border-radius: 6px;
        box-sizing: border-box;
    }
    .bottemList .sameList li:hover {
        box-shadow:0px 0px 16px rgb(0, 0, 0, .2);
    }
    .bottemList .sameList li a{
        display: block;
    }
    .bottemList .sameList li:nth-of-type(3n) {
        margin-right: 0;
    }

    .bottemList .sameList .top .nameWrap {
        float: left;
        width: 70%;
    }

    .bottemList .sameList .top span {
        display: block;
        margin-bottom: 12px;
        font-size: 16px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #333333;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }

    .bottemList .sameList .top i {
        display: inline-block;
        margin-left: 0;
        margin-right: 6px;
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #666666;
    }

    .bottemList .sameList .top .imgWrap {
        float: right;
        width: 54px;
        height: 54px;
        border-radius: 50%;
        overflow: hidden;
    }

    .bottemList .sameList .top .imgWrap img {
        display: block;
        width: 100%;
        height: 100%;
    }

    .bottemList .sameList .center {
        width: 100%;
        overflow: hidden;
    }

    .bottemList .sameList .center .centerItem {
        float: left;
        width: 37%;
        margin-top: 16px;
    }

    .bottemList .sameList .center .centerItem:nth-of-type(3) {
        width: 26%;
    }

    .bottemList .sameList .center .centerItem span {
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: bold;
        color: #333333;
    }

    .bottemList .sameList .center .centerItem p {
        margin-top: 6px;
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #666666;
    }

    .bottemList .sameList .tag {
        border-radius: 2px;
        overflow: hidden;
        margin-top: 14px;
        margin-bottom: 14px;
    }

    .bottemList .sameList .tag span {
        background: #FFF2EB;
        float: left;
        height: 24px;
        line-height: 24px;
        margin-right: 10px;
        margin-bottom: 6px;
        padding: 0 10px;
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: 500;
        color: #FF5C00;
    }

    .bottemList .sameList .bottem {
        width: 100%;
        height: 20px;
        margin-top: 16px;
        font-size: 14px;
        font-family: OPPOSans;
        font-weight: 800;
        color: #FF5C00;
    }

    .bottemList .sameList .bottem .price {
        float: left;
    }

    .bottemList .sameList .bottem .other {
        position: relative;
        float: right;
    }

    .bottemList .sameList .bottem .other i {
        position: absolute;
        top: 0;
        bottom: 0;
        left: -20px;
        margin: auto 0;
        width: 16px;
        height: 16px;
        background: url("../images/icon_comunication.png");
    }
    .videoBoxPart{
      padding: 0 24px 24px;
      margin: 16px 0;
      background: #fff;
      border-radius: 6px;
      box-sizing: border-box;
    }
    .videoHeader{
      display: flex;
      line-height: 72px;
      justify-content: space-between;
      border-bottom: 1px solid #f0f0f0;
    }
    .videoHeader .leftTitle{
      font-weight: 600;
    }
    .videoContent{
    width: 100%;
    /* padding: 0 30px; */
    background: #FFFFFF;
    border-radius: 4px;
    box-sizing: border-box;
  }
  .videoContent h5{
    font-size: 16px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
  }
  .videoContent ul{
    width: 100%;
    padding: 0;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .videoContent ul li{
    position: relative;
    width: 195px;
    height: 488px;
  }
  .videoContent ul li:nth-of-type(3n){
    margin-right: 0;
  }
  .videoContent ul li .video{
    position: relative;
    width: 195px;
    height: 342px;
    background: #000000;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
  }
  .videoContent ul li .video video{
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0;
    width: 100%;
  }
  .video .videoWrap{
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    background:linear-gradient(rgba(0,0,0,0),rgba(0,0,0,.6))
  }
  .video .videoWrap::after{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 1;
    content: '';
    width: 31px;
    height: 35px;
    background: url("../images/icon_play.png") no-repeat center;
  }
  .video .videoWrap1{
    position: absolute;
    z-index: 1;
    width: 45px;
    height: 93px;
    background:linear-gradient(rgba(0,0,0,0),rgba(0,0,0,.6))
  }
  .video .videoWrap1::after{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 1;
    content: '';
    width: 31px;
    height: 35px;
    background: url("../images/icon_play.png") no-repeat center;
    background-size: 50%;
  }

  .videoContent ul li p{
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
  }
  .videoContent ul li .tag i{
    display: inline-block;
    width: 11px;
    height: 11px;
    margin-right: 8px;
    background: url("../images/icon_1.png") no-repeat center;
  }
  .videoContent ul li .tag i:nth-of-type(1){
    width: 8px;
    height: 11px;
    background-image: url("../images/icon_3.png");
  }
  .videoContent ul li .tag i:nth-of-type(3){
    background-image: url("../images/icon_2.png");
  }
  .videoContent ul li .tag span{
    margin-right: 12px;
    font-size: 14px;
    font-family: OPPOSans;
    font-weight: bold;
    color: #666666;
  }
  .alertVideo{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 99;
    background: rgba(0,0,0,.5);
  }
  .alertVideo .videoCard{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    padding: 8px;
    width: 820px;
    height: 646px;
    background: #fff;
    border-radius: 6px;
  }
  .alertVideo .videoCard .videoBox{
    position: relative;
    float: left;
    width: 363px;
    height: 644px;
    border-radius: 4px;
    overflow: hidden;
    background: #000000;
  }
  .alertVideo .videoCard .videoBox video{
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0;
    width: 100%;
  }
  .alertVideo .videoCard .videoInfo{
    float: right;
    width: 390px;
    height: 100%;
    margin-right: 20px;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop{
    margin-top: 30px;
    overflow: hidden;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .photo{
    float: left;
    width: 60px;
    height: 60px;
    margin-top: 14px;
    margin-right: 18px;
    border-radius: 50%;
    box-sizing: border-box;
    overflow: hidden;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .photo img{
    width: 100%;
    height: 100%;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .name{
    float: left;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .name p{
    font-weight: 700;
    font-size: 16px;
    margin-bottom: 0;
  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .name i{
    display: inline-block;
    margin-right: 6px;
    color: #999;
    font-size: 14px;

  }
  .alertVideo .videoCard .videoInfo .videoInfoTop .name b{
    display: inline-block;
    color: #666;
    font-size: 14px;
  }
  .alertVideo .videoCard .videoInfo .tag{
    margin: 10px 0;
    overflow: hidden;
    display: inline-block;
  }
  .alertVideo .videoCard .videoInfo .tag span{
    float: left;
    color: #333;
    font-size: 14px;
    padding: 3px 8px;
    background: #eee;
    border-radius: 4px;
    margin-right: 8px;
  }
  .alertVideo .videoCard .videoInfo p{
    width: 100%;
    margin: 30px 0;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: #333;
  }
  .alertVideo .videoCard .videoInfo .other{
    width: 100%;
  }
  .alertVideo .videoCard .videoInfo .other i{
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-right: 10px;
    line-height: 18px;
    background: url("../images/icon_7.png") no-repeat center bottom;
    background-size: contain;
  }
  .alertVideo .videoCard .videoInfo .other i:nth-of-type(1){
    background-image: url("../images/icon_9.png");
    background-size: contain;
  }
  .alertVideo .videoCard .videoInfo .other i:nth-of-type(3){
    background-image: url("../images/icon_8.png");
    background-size: contain;
  }
  .alertVideo .videoCard .videoInfo .other b{
    display: inline-block;
    margin-right: 20px;
    font-size: 16px;
    color: #333;
    line-height: 18px;
  }
  .alertVideo .close{
    position: absolute;
    top:40px;
    right: 40px;
    width: 21px;
    height: 21px;
    background: url("../images/close.png") no-repeat center;
    cursor: pointer;
  }
  .videoCard .bottom{
    position: absolute;
    bottom: 20px;
    right: 30px;
  }
  .videoCard .bottom a,
  .videoCard .bottom i{
    display: inline-block;
    margin-left: 10px;
    color: #38a1ff;
    font-size: 12px;
    cursor: pointer;
  }
</style>
